import React from 'react';
import { Calendar } from 'lucide-react';

export const GutterOfferBanner = () => {
  return (
    <div className="w-full bg-gradient-to-r from-primary via-primary/90 to-primary/80 border border-primary/20 rounded-lg shadow-lg overflow-hidden mb-8">
      <div className="px-4 py-6 sm:px-6 md:px-8 md:py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Left side - Offer text */}
          <div className="text-center sm:text-left flex-1">
            <div className="inline-flex items-center gap-2 bg-accent/20 text-accent-foreground px-3 py-1 rounded-full text-xs font-semibold mb-2 backdrop-blur-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-foreground opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-foreground"></span>
              </span>
              LIMITED TIME OFFER
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-foreground mb-2">
              Professional Gutter Clearing
            </h2>
            <p className="text-primary-foreground/90 text-base sm:text-lg">
              Complete service for just <span className="font-bold text-xl sm:text-2xl">£80</span>
            </p>
          </div>

          {/* Right side - Countdown */}
          <div className="flex flex-col items-center sm:items-end gap-2 min-w-[200px]">
            <div className="flex items-center gap-2 text-primary-foreground/90">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
              <span className="text-sm font-medium">Offer ends:</span>
            </div>
            <div className="bg-background/10 backdrop-blur-sm border border-primary-foreground/20 rounded-lg px-4 py-2 sm:px-6 sm:py-3">
              <div className="text-primary-foreground text-center">
                <div className="text-2xl sm:text-3xl font-bold">Dec 19</div>
                <div className="text-xs sm:text-sm opacity-90">2024</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
